const modeOptions = [
    {
        label: '配置开通',
        value: 0,
    },
    {
        label: '免费开通',
        value: 1,
    },
    {
        label: '审核开通',
        value: 2,
    },
    {
        label: '付费开通',
        value: 3,
    },
]

const appColumns = [
    {
        title: '应用名称',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '应用LOGO',
        dataIndex: 'icon',
        key: 'icon',
        slots: { customRender: 'icon' },
    },
    {
        title: '应用Code',
        dataIndex: 'code',
        key: 'code',
    },
    {
        title: '应用类别',
        dataIndex: 'typeName',
        key: 'typeName',
    },
    {
        title: '描述',
        dataIndex: 'desc',
        key: 'desc',
    },
    {
        title: '开通模式',
        dataIndex: 'mode',
        key: 'mode',
        slots: { customRender: 'mode' },
    },
    {
        title: '已添加企业',
        dataIndex: 'useCount',
        key: 'useCount',
    },
    {
        title: '上架',
        dataIndex: 'isRelease',
        key: 'isRelease',
        slots: { customRender: 'isRelease' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        slots: { customRender: 'operation' },
    },
]

const reviewColumns = [
    {
        title: '企业名称',
        dataIndex: 'corpName',
        key: 'corpName',
    },
    {
        title: '申请开通应用名称',
        dataIndex: 'appName',
        key: 'appName',
        width: 150,
    },
    {
        title: '申请时间',
        key: 'applyTime',
        slots: { customRender: 'applyTime' },
    },
    {
        title: '审核状态',
        dataIndex: 'status',
        key: 'status',
        slots: { customRender: 'status' },
    },
    {
        title: '审批人',
        dataIndex: 'userName',
        key: 'userName',
    },
    {
        title: '审批时间',
        dataIndex: 'reviewTime',
        key: 'reviewTime',
        slots: { customRender: 'reviewTime' },
    },
    {
        title: '审批说明',
        dataIndex: 'reviewDesc',
        key: 'reviewDesc',
    },
    {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        slots: { customRender: 'operate' },
    },
]

export { modeOptions, appColumns, reviewColumns }
